import { render } from "./BaseLogFieldProjectManagement.vue?vue&type=template&id=5ec8822c"
import script from "./BaseLogFieldProjectManagement.vue?vue&type=script&lang=js"
export * from "./BaseLogFieldProjectManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__